import { computed, defineComponent, ref } from 'vue'

import { CsCopyTextLink, CsPrimaryButton } from '@sunrise/components'
import { screenSizeDetection } from '@sunrise/shared'

import { useMailAgentStore } from '../../ts/store/mailAgentStoreModule/mailAgentStoreModule'

import MsDynamicTags from '../MsDynamicTags/MsDynamicTags.vue'
import { MailAgentTrackingVariant } from '../MsMailAgentModal/MsMailAgentModal.enum'
import MsMailAgentModal from '../MsMailAgentModal/MsMailAgentModal.vue'
import MsMailAlertIcon from './mailAlertIcon.svg?component'
import MsCircle from './realEstateCircleBrandCircle-3.svg?component'
import MsHouse from './realEstateHouseBrandHouse-3.svg?component'

export default defineComponent({
    name: 'MsMailAgentBanner',
    components: {
        CsCopyTextLink,
        CsPrimaryButton,
        MsDynamicTags,
        MsMailAgentModal,
        MsMailAlertIcon,
        MsCircle,
        MsHouse,
    },
    props: {
        trackingVariant: {
            type: String as () => MailAgentTrackingVariant,
            required: true,
        },
        privacyPoliceUrl: String,
    },

    setup() {
        const { isScreenM, isScreenL } = screenSizeDetection()
        const modalIsVisible = ref<boolean>(false)
        const mailAgentStore = useMailAgentStore()
        const tags = computed(() => mailAgentStore.tagsAsArray)

        function openModal() {
            modalIsVisible.value = true
        }

        function closeModal() {
            modalIsVisible.value = false
        }

        return {
            modalIsVisible,
            openModal,
            closeModal,
            tags,
            MailAgentTrackingVariant,
            isScreenM,
            isScreenL,
        }
    },
})
